export default "__VITE_ASSET__DXoAQHjz__"